var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable } from 'mobx';
export class SortableEvents {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    getSortableItem(e) {
        return this.question.sortableStore.sortableItems.find((sortableItem) => sortableItem.id_string === e.draggableId);
    }
    onDragStart(e) {
        const sortableItem = this.getSortableItem(e);
        sortableItem.isDragging = true;
        //  sortableItem.isDraggingSourceIndex = e.source.index;
        // sortableItem.isDraggingSourceDroppableId = e.source.droppableId;
        sortableItem.isDraggingDestinationIndex = undefined;
        sortableItem.isDraggingDestinationDroppableId = '';
        // console.log('onDragStart', e);
    }
    onDragUpdate(e) {
        if (!e.destination)
            return;
        const sortableItem = this.getSortableItem(e);
        sortableItem.isDragging = true;
        //   sortableItem.isDraggingSourceIndex = e.source.index;
        //   sortableItem.isDraggingSourceDroppableId = e.source.droppableId;
        sortableItem.isDraggingDestinationIndex = e.destination.index;
        sortableItem.isDraggingDestinationDroppableId = e.destination.droppableId;
        // console.log('onDragUpdate', e);
    }
    onDragEnd(e) {
        console.log('onDragEnd', e);
        if (!e.destination)
            return;
        const { source, destination } = e;
        // dropped outside the list
        if (!destination) {
            return;
        }
        const sortableItem = this.getSortableItem(e);
        sortableItem.isDragging = false;
        // sortableItem.isDraggingSourceIndex = undefined;
        sortableItem.isDraggingDestinationIndex = undefined;
        // sortableItem.isDraggingSourceDroppableId = undefined;
        sortableItem.isDraggingDestinationDroppableId = undefined;
        const sourceList = this.question.sortableLists.getListById(source.droppableId);
        // sourceList.listItems.removeFromIndex(sortableItem, source.index);
        const destinationList = this.question.sortableLists.getListById(destination.droppableId);
        //  destinationList.listItems.insertToIndex(sortableItem, destination.index);
        if (source.droppableId === destination.droppableId) {
            const items = reorder(sourceList.listItems.currentSortableItems, source.index, destination.index);
            items.forEach((item, index) => (item.indexInDroppable = index));
        }
        else {
            const [newSourceListItems, newDestinationListItems] = move(sourceList.listItems.currentSortableItems, destinationList.listItems.currentSortableItems, source, destination);
            newSourceListItems.forEach((item, index) => {
                item.indexInDroppable = index;
                item.droppableId = sourceList.id_string;
            });
            newDestinationListItems.forEach((item, index) => {
                item.indexInDroppable = index;
                item.droppableId = destinationList.id_string;
            });
        }
        this.question.sortableMoves.moveHistory.push(e);
    }
    onWrongComplete() {
        this.question.questionScore.manifestedPoints = this.question.questionScore.manifestedPoints;
        this.question.questionScore.manifestedOverallState = this.question.sortableExtractState.currentOverallState;
    }
}
__decorate([
    action.bound
], SortableEvents.prototype, "onDragStart", null);
__decorate([
    action.bound
], SortableEvents.prototype, "onDragUpdate", null);
__decorate([
    action.bound
], SortableEvents.prototype, "onDragEnd", null);
// a little function to help us with reordering the result
function reorder(list, startIndex, endIndex) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
}
/**
 * Moves an item from one list to another list.
 */
function move(source, destination, droppableSource, droppableDestination) {
    const sourceClone = source.concat();
    const destClone = destination.concat();
    const [removed] = sourceClone.splice(droppableSource.index, 1);
    destClone.splice(droppableDestination.index, 0, removed);
    return [sourceClone, destClone];
}
